import styled from 'styled-components';
import { SideNavColorSchemeIndex, SideNavColorSchemeProps } from '../..';
import { localTheme } from '../../../../styles/local-theme';

const textColorSchemes: SideNavColorSchemeIndex = {
  dark: localTheme.colors.iceGray,
  blue: localTheme.colors.paleBlue,
};

const NoItemsToDisplay = styled.div<SideNavColorSchemeProps>`
  color: ${(props): string => textColorSchemes[props.colorScheme]};
  margin-top: ${(props): string => props.theme.spaces.md};
  margin-bottom: ${(props): string => props.theme.spaces.md};
  font-style: italic;
  font-size: 12px;
`;

export { NoItemsToDisplay };
